import API from "../api";
import { Commit } from "vuex";
import { PayloadTransmissionAccess } from "../types";
export default {
  namespaced: true,
  state: {
    currentTransmission: {
      id: 0,
      title: "",
      startTime: "",
      duration: 0,
      notifyBeforeMinutes: 0,
      started: true,
      type: "",
      events: [
        {
          id: 0,
          name: "",
        },
      ],
      lounges: [
        {
          id: 0,
          name: "",
          color: "",
        },
      ],
      meetingId: 0,
      url: "",
      password: "",
      config: {
        expiredIn: "",
        token: "",
        sdkAppKey: "",
        expired: true,
      },
    },
    nextTransmissionList: [],
  },
  mutations: {
    setCurrentTransmission(state: any, payload: any) {
      state.currentTransmission = payload;
    },
    setNextTransmissionList(state: any, payload: any) {
      state.nextTransmissionList = payload;
    },
  },
  actions: {
    async requestEditTransmission(context: any, payload: any): Promise<any> {
      const { data } = await API.putTransmission(payload);
      return data;
    },
    async requestTransmissionZoom(context: any, id: string): Promise<any> {
      const { data } = await API.getTransmissionZoom(id);
      return data;
    },
    async requestCurrentTransmission({
      commit,
    }: {
      commit: Commit;
    }): Promise<any> {
      const { data } = await API.getCurrentTransmission();
      commit("setCurrentTransmission", data);
      return data;
    },
    async requestEditCurrentTransmission(
      context: any,
      payload: any
    ): Promise<any> {
      const { data } = await API.getCurrentTransmissionEdit(payload);
      return data;
    },
    async requestCurrentTransmissionById(
      context: any,
      payload: string
    ): Promise<any> {
      const { data } = await API.getCurrentTransmissionById(payload);
      return data;
    },
    async requestNewTransmission(context: any, payload: any): Promise<any> {
      const { data } = await API.postTransmission(payload);
      return data;
    },
    async requestNextTransmissionList({
      commit,
    }: {
      commit: Commit;
    }): Promise<any> {
      const { data } = await API.getNextTransmissionList();
      commit("setNextTransmissionList", data);
      return data;
    },
    updateNextTransmissionList(
      {
        commit,
      }: {
        commit: Commit;
      },
      payload: any
    ): void {
      commit("setNextTransmissionList", payload);
    },
    async requestCreateAccess(
      context: any,
      payload: PayloadTransmissionAccess
    ): Promise<any> {
      const { data } = await API.postCreateAccess(payload);
      return data;
    },
  },
  modules: {},
};
